import { SplideSlide } from "@splidejs/react-splide";
import { Title, Caption } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";
import Image from "next/image";
import apple from "@/public/apple.svg";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { cmsUrl } from "@/app/config";
import { useRouter } from "next/navigation";
import appleDark from "@/public/appleDark.svg";
import Link from "next/link";
import { useState, useEffect } from "react";

const bannerVariant = cva("absolute ", {
  variants: {
    variant: {
      top: "top-[100px] left-[50%] translate-x-[-50%] mt-[36] md:mt-[20px] lg:mt-[20px] 2xl:mt-[25px] text-center text-midnightIndigo-400px flex flex-col justify-center items-center",
      center:
        " w-full top-[10%] top-[30%] md:top-[40%] lg:top-[5%] left-[50%] translate-x-[-50%] text-center text-midnightIndigo-400px flex flex-col justify-center items-center",
      left: " text-left top-[25%] lg:max-w-[40%] md:top-[25%] left-[6%] md:left-[6%]  lg:top-[30%] lg:left-[0%] text-midnightIndigo-400px lg:pl-10 ",
    },
  },
  defaultVariants: {
    variant: "top",
  },
});

export default function BannerTemplate({ slide, variant = "top", theme = "light", ...props }) {
  const router = useRouter();
  const [imageLoaded, setImageLoaded] = useState(false);

  // Preload the image
  useEffect(() => {
    if (slide?.image?.url) {
      const img = new window.Image();
      img.src = `${cmsUrl}${slide.image.url}`;
      img.onload = () => setImageLoaded(true);
    }
  }, [slide?.image?.url]);

  return (
    <SplideSlide>
      <div
        className={`bg-cover relative h-[calc(100vh-130px)] md:min-h-[600px] md:h-[calc(100vh-255px)] transition-opacity duration-500 ${
          imageLoaded ? "opacity-100" : "opacity-0"
        }`}
        style={{
          backgroundImage: `url(${cmsUrl}${slide?.image?.url})`,
          backgroundColor: "#f0f0f0", // Placeholder color while loading
        }}
      >
        {/* Add HTML content inside each slide */}
        <div className={cn(bannerVariant({ variant }), "slide-text ")}>
          <Title
            size="xxl"
            className={`user-select-text ${
              theme === "light" ? "text-system-disabled" : "text-midnightIndigo-400"
            }  mb-[10px] 2xl:mb-[.69vw] leading[120%] text-[32px]  2xl:text-[2.9vw]   w-[300px] md:w-[469px] lg:w-full  leading-[38.4px] md:leading-[43.2px] lg:leading-[120%] `}
          >
            {slide.title}
          </Title>
          <Caption
            className={`user-select-text ${
              theme === "light" ? "text-system-disabled" : "text-midnightIndigo-400"
            }  mb-5 md:mb-4 lg:mb-5 md:w-[469px]  w-[200px] lg:w-full !lg:text-[19px] !text-[14px] xl:!text-[1.3vw]  2xl:mb-[1.6vw] `}
          >
            {slide.subtitle}
          </Caption>
          <Link href={slide?.url !== null ? `${slide?.bottomLink}` : "/"}>
            <Button
              size="default"
              className="2xl:w-[8.7vw] text-[16px]"
              onClick={() => {
                const url = slide?.bottomLink !== null ? `${slide?.bottomLink}` : "/";
                router.push(url);
              }}
              title={slide.buttonText}
            >
              {slide.buttonText}
            </Button>
          </Link>
        </div>
        {theme === "light" ? (
          <Image
            src={apple}
            height={39}
            width={145}
            alt="logo"
            className="relative hidden md:block pt-[400px] md:pt-[0%] mx-auto  md:absolute left-[3%] bottom-[5%] "
          />
        ) : (
          <Image
            src={appleDark}
            height={39}
            width={145}
            alt="logo"
            className="relative hidden md:block pt-[400px] md:pt-[0%] mx-auto  md:absolute left-[3%] bottom-[5%] fill-black"
          />
        )}
      </div>
    </SplideSlide>
  );
}
